// extracted by mini-css-extract-plugin
export default {"tabs_container":"TabsNew_tabs_container__WJPzQ","tab":"TabsNew_tab__bEXGu"};